import styled from "styled-components";

interface SideMenuItemStyleProps {
  $icon: boolean;
}

export const UserSideMenuItem = styled.li<SideMenuItemStyleProps>`
  display: grid;
  width: 100vw;
  height: 56px;
  padding: 16px 26px;
  background: ${(props) => props.theme.colors.white100};
  grid-template-columns: ${(props) =>
    props.$icon ? "20px auto 24px" : "auto 24px"};
  align-items: center;
  gap: 14px;

  svg:last-child {
    path {
      fill: ${(props) => props.theme.colors.black50};
    }
  }

  &:active {
    background: ${(props) => props.theme.colors.primary8};

    div {
      color: ${(props) => props.theme.colors.primary100};
      font-weight: 700;
    }

    svg {
      path {
        fill: ${(props) => props.theme.colors.primary100};
        fill-opacity: 1;
      }
    }
  }
`;

export const UserSideMenuTitle = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.black80};
  font-size: 1.4rem;
`;
